/*
 * File: /src/services/webhook.js
 * Created Date: Thursday November 4th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 14th December 2021 3:47:03 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_WEBHOOK_PATH } from '../constants';

export default {
  fetchAll() {
    return authedAxios.get(AD_BASE_WEBHOOK_PATH);
  },
  fetchById(id) {
    return authedAxios.get(AD_BASE_WEBHOOK_PATH + id);
  },

  updateWebhook(id, payload) {
    return authedAxios.put(AD_BASE_WEBHOOK_PATH + id, payload);
  },

  createWebhook(payload) {
    return authedAxios.post(AD_BASE_WEBHOOK_PATH, payload);
  }
};
